import React from "react";
import { Routes, Route } from "react-router-dom";
import UserManagement from "./userManagement";

const UserManagementRouter = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        bottom: "0px",
        top: "60px",
        right: "0px",
        left: "0px",
        alignItems: "center",
      }}
      className="userManagement-router"
    >
      <Routes>
        <Route path="/*" element={<UserManagement />} />
        {/* If you need additional routes later:
        <Route path="le/*" element={<UpdateLE />} />
        <Route path="plan/*" element={<UpdatePlan />} />
        */}
      </Routes>
    </div>
  );
};

export default UserManagementRouter;
